/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import type { BillingDetails } from '@modules/billing-api/customTypes'
import {
  isCreditCardCustomer,
  isPurchaseOrderCustomer,
  isConsumptionProcessing,
} from '@modules/billing-lib/billingDetails/utils'

export const canUpdateCreditCardDetails = (billingDetails: BillingDetails) => {
  // CC customer can add/update card details
  if (isCreditCardCustomer(billingDetails)) {
    return true
  }

  // Monthly PO customers can switch to CC if they are not on consumption engine
  if (isPurchaseOrderCustomer(billingDetails) && !isConsumptionProcessing(billingDetails)) {
    return true
  }

  return false
}
